import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function UrgencyScarcity() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section className="py-12 px-4" data-id="element-260">
      <div className="max-w-4xl mx-auto" data-id="element-261">
        <div ref={ref} className={`bg-amber-950/30 border border-amber-500/30 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center ${isVisible ? 'anim-fade-up' : 'anim-hidden'}`} data-id="element-262">
          <div className="bg-amber-500/20 p-4 rounded-full shrink-0" data-id="element-263">
            <AlertTriangle className="w-8 h-8 text-amber-500" data-id="element-264" />
          </div>
          <div className="space-y-3" data-id="element-265">
            <h3 className="text-xl font-bold text-amber-500 flex items-center gap-2" data-id="element-266">
              Este precio de lanzamiento es temporal.
            </h3>
            <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-267">
              El Pack Completo de 6 Tomos está disponible hoy a precio de
              introducción. Una vez que terminemos esta fase de lanzamiento, el
              precio sube. No hay fecha exacta — puede ser mañana, puede ser en
              3 días.
            </p>
            <p className="text-white font-semibold text-sm md:text-base" data-id="element-268">
              Lo que sí es seguro: el precio que ves ahora es el más bajo que
              vas a ver nunca.
            </p>
          </div>
        </div>
      </div>
    </section>;
}